import moment from 'moment';
import { getTimeRangeForUri } from 'services/config/selectors';
import { setTimeRange, setTimeRangeByKey, timeRanges } from 'services/config/duck';
import { cloneDeep } from 'lodash';

exports.getQueryParamDefForRange = () => ({
    range: {
        selector: getTimeRangeForUri,
        action: (value) => {
            // Break, Check if range is KEY of default sets (i.e. last-30-days)
            if (Object.keys(timeRanges).indexOf(value) > -1) {
                return setTimeRangeByKey(value);
            } else if (/([0-9]){4}-([0-9]){2}-([0-9]){2}_([0-9]){4}-([0-9]){2}-([0-9]){2}/.test(value)) {
                // This block is if the value updated is a custom range
                const [start, end] = value.split('_');
                const rangeObj = cloneDeep(timeRanges['custom-range']);
                rangeObj.apiConfig.start = () => moment(start)
                    .startOf('day').add(12, 'hours');
                rangeObj.apiConfig.end = () => moment(end)
                    .startOf('day').add(12, 'hours');
                return setTimeRange(rangeObj);
            }
            // else NOOP
            return { type: 'NOOP', payload: 'TVDashboard(range)' };
        }
    },
});



// WEBPACK FOOTER //
// ./src/helpers/range.js